/*
 * CartSave — attach an email to the Ajax cart and hand it to Klaviyo for recovery.
 * Config: #cartsave-config (snippets/cartsave.liquid). Docs: docs/dev/cartsave.md.
 *
 * F0 cart listener + identity · F1 email prompt n seconds after add-to-cart · F2 exit intent ·
 * F3 embedded form · F4 other forms · F5 email-click (_kx) · F6 reclaim URL.
 * No backend: reclaim links are self-contained (`?c=`), nothing is reported.
 *
 * Cart requests are observed through the shared `cart:mutation` event
 * (snippets/cart-request-hook.liquid) — never wrap fetch/XHR here.
 * Every entry point is wrapped so a failure can never affect add-to-cart,
 * the drawer or checkout; errors go to console.debug only.
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('cartsave-config');
  if (!cfgEl || window.CartSave) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  // Liquid's `t` filter HTML-escapes (it's → it&#39;s); decode once here because
  // esc() escapes again when the text is inserted.
  var T = C.t || {}, ta = document.createElement('textarea');
  for (var tk in T) { ta.innerHTML = T[tk]; T[tk] = ta.value; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || C.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var RESTORE = location.origin + ROOT + C.restorePath;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var DAY = 864e5;

  function dbg() { try { console.debug.apply(console, ['[cartsave]'].concat([].slice.call(arguments))); } catch (e) {} }
  function guard(fn) { return function () { try { return fn.apply(this, arguments); } catch (e) { dbg(e); } }; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }

  // ---- Storage (every access guarded) ---------------------------------------
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // cs_state: { email, source, captured_at, identified, prompt_dismissed_at,
  //             last_cart_saved_token, source_sent, pd (profile dirty ts) }
  var state = lsGet('cs_state') || {};
  function save(patch) { for (var k in patch) state[k] = patch[k]; lsSet('cs_state', state); }

  var DEVICE = matchMedia('(pointer: coarse)').matches || innerWidth < 768 ? 'mobile' : 'desktop';

  // ---- Cart helpers -------------------------------------------------------
  var current = null;
  function normToken(t) { return t ? String(t).split('?')[0] : ''; }
  function money(c) { return Math.round(c || 0) / 100; }
  function money2(a, b) { return money(a != null ? a : b); }
  function abs(u) {
    if (!u) return '';
    if (/^https?:/i.test(u)) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    return location.origin + (u.charAt(0) === '/' ? '' : '/') + u;
  }
  function img(u) { u = abs(u); return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=400' : ''; }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); });
  }
  function setAttrs(attrs) {
    return fetch(ROOT + 'cart/update.js?cs=1', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(dbg);
  }
  // keep(k): which keys survive. Snapshot drops only `_cs_*`; the Klaviyo
  // payload drops every private `_` key.
  function pick(o, keep) {
    var out = {}, n = 0;
    if (o) for (var k in o) { if (o[k] != null && o[k] !== '' && keep(k)) { out[k] = o[k]; n++; } }
    return n ? out : null;
  }
  function notCs(k) { return k.indexOf('_cs_') !== 0; }
  function isPublic(k) { return k.charAt(0) !== '_'; }

  // ---- F6 reclaim URL (spec §4.3) -----------------------------------------
  function snapshot(cart) {
    return {
      v: 1,
      i: cart.items.map(function (it) {
        var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
        return [it.variant_id || it.id, it.quantity, pick(it.properties, notCs), sp ? sp.id : null];
      }),
      a: pick(cart.attributes, notCs),
      n: cart.note || null
    };
  }
  function b64u(str) {
    var bytes = new TextEncoder().encode(str), bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function reclaimUrl(cart) {
    return RESTORE + '?c=' + b64u(JSON.stringify(snapshot(cart)));
  }

  // ---- Klaviyo (onsite object only; waits ≤10s) -----------------------------
  // `window.klaviyo` is a Proxy: EVERY property (including `then`) is a function,
  // so it is a thenable. Never resolve a promise with it or with values its
  // methods return — that waits forever. Wrap it, and only chain on native
  // Promises (capped at 10s).
  function settle(v) {
    return v instanceof Promise ? Promise.race([v, wait(10000)]) : Promise.resolve();
  }
  function kl() {
    var t0 = Date.now();
    return new Promise(function (res, rej) {
      (function poll() {
        var k = window.klaviyo;
        if (k && typeof k.track === 'function') {
          return res({
            identify: function (p) { return settle(k.identify(p)); },
            track: function (n, p) { return settle(k.track(n, p)); },
            isIdentified: function () { return settle(k.isIdentified()); }
          });
        }
        if (Date.now() - t0 > 10000) return rej('klaviyo');
        setTimeout(poll, 200);
      })();
    });
  }
  // 'identified' | 'anon' | 'na' (Klaviyo unavailable → no capture possible)
  function klState() {
    return kl().then(function (k) { return typeof k.isIdentified === 'function' ? k.isIdentified() : false; })
      .then(function (b) { if (b) save({ identified: true }); return b ? 'identified' : 'anon'; }, function () { return 'na'; });
  }
  function companyId() {
    if (window.__klKey) return window.__klKey;
    var s = document.querySelector('script[src*="company_id="]');
    var m = s && s.src.match(/[?&]company_id=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  // Client Subscriptions API (public key). Only for an explicit opt-in tick.
  function subscribe(email) {
    var cid = companyId();
    if (!cid || !C.listId) return Promise.resolve();
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cid), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: { custom_source: 'CartSave', profile: { data: { type: 'profile', attributes: {
          email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: C.listId } } }
      } })
    }).catch(dbg);
  }

  // ---- Cart Saved + profile (spec §4.1, §4.2) ------------------------------
  // YMQ product options: rebuild the `option-value` param YMQ reads on the product
  // page, so the link reopens with the same selections. Prefer the ordered
  // `__ymq_option_info` (keys prefixed "_"), else visible properties; drop YMQ's
  // price suffix "(+$60.00)". Same logic in snippets/klaviyo-added-to-cart.liquid.
  function productUrl(it) {
    var base = abs(it.url), p = it.properties || {}, src = null, opts = {}, n = 0;
    try { src = JSON.parse(p.__ymq_option_info); } catch (e) {}
    var info = !!src;
    src = src || p;
    for (var k in src) {
      var key = info ? k.replace(/^_/, '') : k;
      if (!key || key.charAt(0) === '_' || src[k] == null || src[k] === '') continue;
      opts[key] = String(src[k]).replace(/\([+-][^()]*\)$/, '');
      n++;
    }
    if (!n) return base;
    opts.ymq_product_quantity = it.quantity;
    try {
      var u = new URL(base);
      u.searchParams.set('option-value', encodeURIComponent(JSON.stringify(opts)));
      return u.toString();
    } catch (e) { return base; }
  }
  function propList(o) {
    o = pick(o, isPublic) || {};
    return Object.keys(o).map(function (k) { return { name: k, value: String(o[k]) }; });
  }
  // Shape matches the "Cart Started" event the CartSave Recovery email templates were
  // built on: event.extra.line_items[] → item.quantity, item.product.{name,price,images.0.url}.
  function lineItems(cart) {
    return cart.items.map(function (it) {
      var name = it.product_title || it.title;
      return {
        quantity: it.quantity,
        row_total: money2(it.final_line_price, it.line_price),
        product: {
          id: it.product_id,
          variant_id: it.variant_id || it.id,
          name: name,
          simple_name: name,
          variant_title: it.variant_title || '',
          sku: it.sku || '',
          price: money2(it.original_price, it.price),
          special_price: money(it.price),
          discounted_price: money2(it.final_price, it.price),
          total_discount: money(it.total_discount),
          images: [{ url: img(it.image || (it.featured_image && it.featured_image.url)) }],
          url: productUrl(it)
        },
        // [{name, value}] so email templates can loop over it
        properties: propList(it.properties)
      };
    });
  }
  function profileProps(cart, url, at) {
    return { cs_last_cart_url: url, cs_last_cart_value: money(cart.total_price), cs_last_cart_at: at || new Date().toISOString() };
  }
  // Rejects when Klaviyo is unavailable so prompts can show an error.
  // klaviyo.track() resolves before its XHR lands, and a redirect (e.g. to /cart
  // right after add-to-cart, or a form post) aborts it. So nothing is marked sent
  // until the page has survived 4s; otherwise the next page re-sends, and the fixed
  // $event_id (one passive + one prompt event per cart) lets Klaviyo dedupe it.
  function cartSaved(cart, source, isPrompt, email, after) {
    var token = normToken(cart.token);
    var url = reclaimUrl(cart), li = lineItems(cart);
    var props = profileProps(cart, url);
    if (!state.source_sent && source) props.cs_capture_source = source;
    if (email) props.email = email;
    return kl().then(function (k) {
      return Promise.resolve(k.identify(props)).then(function () {
        return k.track('Cart Saved', {
          $event_id: token + (isPrompt ? ':p' : ''),
          is_prompt: isPrompt,
          capture_source: source,
          cart_token: token,
          reclaimURL: url,
          currency: cart.currency,
          $value: money(cart.total_price),
          items: li.map(function (i) { return i.product.name; }),
          'Total Discount': money(cart.total_discount),
          'Items Count': cart.item_count,
          market: C.market,
          $extra: { line_items: li, checkout_url: location.origin + ROOT + 'cart', checkout_id: token }
        });
      });
    }).then(function () {
      setTimeout(function () {
        var p = { last_cart_saved_token: token, pd: 0 };
        if (props.cs_capture_source) p.source_sent = 1;
        save(p);
        if (!(cart.attributes && cart.attributes._cs_source)) setAttrs({ _cs_source: source });
        if (after) after();
      }, 4000);
    });
  }

  // Explicit (F1–F3) or form-observed (F4) email capture.
  function capture(email, source, isPrompt, consent) {
    if (!state.source) save({ source: source, captured_at: new Date().toISOString() });
    save({ email: email });
    var token;
    return getCart().then(function (cart) {
      current = cart;
      token = normToken(cart.token);
      // Passive capture: one Cart Saved per cart token.
      if (!cart.item_count || (!isPrompt && state.last_cart_saved_token === token)) {
        return kl().then(function (k) { return k.identify({ email: email }); });
      }
      passiveBusy[token] = 1; // keep passive() from racing this capture
      return cartSaved(cart, source, isPrompt, email);
    }).then(function () {
      delete passiveBusy[token];
      if (consent) return subscribe(email);
    }, function (e) { delete passiveBusy[token]; throw e; });
  }

  // Identity already known when a cart appears → "first association" for this token.
  var passiveBusy = {};
  function passive(cart) {
    var token = normToken(cart.token);
    if (!cart.item_count || state.last_cart_saved_token === token || passiveBusy[token]) return;
    passiveBusy[token] = 1;
    var p;
    if (C.customerEmail) p = Promise.resolve({ email: C.customerEmail, source: 'customer_account' });
    else if (state.email) p = Promise.resolve({ email: state.email, source: state.source || 'other_form' });
    else p = klState().then(function (s) {
      if (s !== 'identified') return null;
      // F5: arrived from a Klaviyo email (_kx) this session.
      var src = ssGet('cs_pending') || state.source;
      return src ? { email: null, source: src } : null;
    });
    p.then(function (id) {
      if (!id) return;
      if (!state.source && id.source !== 'customer_account') save({ source: id.source, captured_at: new Date().toISOString() });
      return cartSaved(cart, id.source, false, id.email);
    }).catch(dbg).then(function () { delete passiveBusy[token]; });
  }

  // Profile properties follow the latest cart, debounced 30s (survives navigation via state.pd).
  var profTimer;
  function markProfileDirty() {
    if (!(C.customerEmail || state.email || state.identified)) return;
    if (!state.pd) save({ pd: Date.now() });
    clearTimeout(profTimer);
    profTimer = setTimeout(flushProfile, 30000);
  }
  function flushProfile() {
    if (!state.pd) return;
    var at = new Date(state.pd).toISOString();
    getCart().then(function (cart) {
      if (!cart.item_count) return;
      var props = profileProps(cart, reclaimUrl(cart), at);
      if (C.customerEmail) props.email = C.customerEmail;
      else if (state.email) props.email = state.email;
      return kl().then(function (k) { return k.identify(props); });
    }).then(function () { save({ pd: 0 }); }).catch(dbg);
  }

  // ---- F0 cart listener -----------------------------------------------------
  // cs_cart {t, n} persists across page loads, which also covers full-page
  // (non-Ajax) POST /cart/add: the next load sees a different token/count.
  var syncTimer;
  function sync(initial) {
    return getCart().then(function (cart) {
      var prev = lsGet('cs_cart'), t = normToken(cart.token), n = cart.item_count;
      var changed = !prev || prev.t !== t || prev.n !== n;
      current = cart;
      lsSet('cs_cart', { t: t, n: n });
      if (!initial || changed) {
        markProfileDirty();
      }
      if (n > 0) passive(cart);
    }).catch(dbg);
  }
  document.addEventListener('cart:mutation', function (e) {
    if (e.detail && e.detail.internal) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(guard(sync), 300);
  });

  // ---- Prompt dialog (F1 / F2) ----------------------------------------------
  var cssP;
  function loadCss() {
    return cssP || (cssP = new Promise(function (res) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = C.css;
      l.onload = l.onerror = res;
      setTimeout(res, 3000);
      document.head.appendChild(l);
    }));
  }
  function suppressed(cart) {
    if (C.customerEmail || state.email || state.identified || ssGet('cs_prompted')) return true;
    if (cart && cart.attributes && cart.attributes._cs_restored) return true;
    var d = state.prompt_dismissed_at;
    return !!(d && Date.now() - d < (C.dismissDays || 7) * DAY);
  }

  var dlg, dlgSource, lastFocus, paused = [];
  function focusables() {
    return [].filter.call(dlg.querySelectorAll('button, input, a[href]'), function (n) { return !n.disabled && n.offsetParent; });
  }
  function buildDialog() {
    var w = document.createElement('div');
    w.className = 'cs-overlay';
    w.hidden = true;
    w.innerHTML =
      '<div class="cs-dialog" role="dialog" aria-modal="true" aria-labelledby="cs-title" aria-describedby="cs-text">' +
        '<button type="button" class="cs-close" data-cs-close aria-label="' + esc(T.close) + '">&times;</button>' +
        '<h2 id="cs-title" class="cs-title">' + esc(T.title) + '</h2>' +
        '<p id="cs-text" class="cs-text">' + esc(T.text) + '</p>' +
        '<form class="cs-form" data-cs-form novalidate>' +
          '<label class="cs-sr" for="cs-email">' + esc(T.placeholder) + '</label>' +
          '<input id="cs-email" class="cs-input" type="email" name="email" autocomplete="email" placeholder="' + esc(T.placeholder) + '">' +
          '<label class="cs-consent"><input type="checkbox" name="consent"><span>' + esc(T.consent) + '</span></label>' +
          '<button type="submit" class="cs-btn">' + esc(T.button) + '</button>' +
          '<p class="cs-error" role="alert"></p>' +
        '</form>' +
        '<p class="cs-success" role="status" hidden>' + esc(T.success) + '</p>' +
      '</div>';
    document.body.appendChild(w);
    w.addEventListener('click', function (e) {
      if (e.target === w || e.target.closest('[data-cs-close]')) closeDialog(true);
    });
    w.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closeDialog(true); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var form = w.querySelector('form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitEmail(form, dlgSource, form.consent.checked, function () {
        form.hidden = true;
        w.querySelector('.cs-success').hidden = false;
        w.querySelector('.cs-close').focus();
        setTimeout(function () { closeDialog(false); }, 2000);
      });
    });
    return w;
  }
  function openPrompt(source) {
    if (ssGet('cs_prompted')) { promptDone(); return; }
    ssSet('cs_prompted', source);
    dlgSource = source;
    loadCss().then(function () {
      dlg = dlg || buildDialog();
      var form = dlg.querySelector('form');
      form.hidden = false;
      form.reset();
      form.querySelector('button.cs-btn').textContent = T.button;
      form.querySelector('.cs-error').textContent = '';
      dlg.querySelector('.cs-success').hidden = true;
      lastFocus = document.activeElement;
      // Pause the theme drawer's focus trap so it doesn't pull focus back.
      paused = (window.activeModals || []).map(function (m) { return m && m.focusTrap; })
        .filter(function (t) { return t && typeof t.pause === 'function'; });
      paused.forEach(function (t) { try { t.pause(); } catch (e) {} });
      dlg.hidden = false;
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      form.email.focus();
    }).catch(function (e) { dbg(e); promptDone(); });
  }
  function closeDialog(dismissed) {
    if (!dlg || dlg.hidden) return;
    dlg.classList.remove('is-open');
    dlg.hidden = true;
    paused.forEach(function (t) { try { t.unpause(); } catch (e) {} });
    paused = [];
    if (dismissed) save({ prompt_dismissed_at: Date.now() });
    try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
    promptDone();
  }

  // Shared by the dialog and the embedded entry. `box` holds .cs-error + an email input.
  // Returns the trimmed email, or null after showing the validation error.
  function checkEmail(box) {
    var input = box.querySelector('input[type=email]'), err = box.querySelector('.cs-error');
    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      err.textContent = T.errorEmail;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return null;
    }
    input.removeAttribute('aria-invalid');
    err.textContent = '';
    return email;
  }
  function submitEmail(box, source, consent, onOk) {
    var btn = box.querySelector('button.cs-btn'), err = box.querySelector('.cs-error');
    var email = checkEmail(box);
    if (!email) return;
    btn.disabled = true;
    capture(email, source, true, consent).then(onOk, function (e) {
      dbg(e);
      err.textContent = T.errorGeneric;
    }).then(function () { btn.disabled = false; });
  }

  // F1: hold the theme's post-add redirect to /cart until the email prompt is
  // done. The theme calls window.cartSaveAfterAdd(go) from its
  // `product:added-to-cart` listener (layout/theme.liquid, "page" notification
  // mode): unknown-email visitors get the dialog and go() runs when it is
  // submitted or closed; everyone else goes straight through. One popup per
  // session (cs_prompted in suppressed()); Klaviyo-identified visitors skip the
  // dialog after a short identification check; if Klaviyo is slow/unavailable
  // the dialog still shows (only a positive "identified" skips it).
  function f1Skip() {
    return !C.f1 || !!C.customerEmail || !!state.email || !!state.identified || !!ssGet('cs_prompted');
  }
  var afterPrompt = null;
  function promptDone() {
    var fn = afterPrompt;
    afterPrompt = null;
    if (fn) { try { fn(); } catch (e) { dbg(e); } }
  }
  if (C.f1) {
    window.cartSaveAfterAdd = function (go) {
      try {
        if (f1Skip()) return go();
        // Identified via Klaviyo (e.g. earlier email click) → no dialog. Wait ≤1.2s.
        klState().then(function (s) {
          if (s === 'identified' || f1Skip()) return go();
          afterPrompt = go;
          openPrompt('atc_prompt');
        }, go);
      } catch (e) { dbg(e); go(); }
    };
  }

  // F2: exit intent.
  function initExit() {
    if (!C.f2) return;
    var t0 = Date.now(), busy = 0;
    function fire() {
      if (busy || Date.now() - t0 < 5000 || !current || !current.item_count || suppressed(current)) return;
      busy = 1;
      klState().then(function (s) {
        busy = 0;
        if (s === 'anon' && !suppressed(current)) openPrompt('exit_intent');
      });
    }
    if (DEVICE === 'desktop') {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });
      return;
    }
    // Mobile: fast upward fling near the top, or 30s idle on the cart page.
    // Never hijack the back button (no history.pushState).
    var ly = scrollY, lt = Date.now();
    addEventListener('scroll', function () {
      var y = scrollY, now = Date.now(), dt = now - lt;
      if (dt > 0 && y < ly && y < innerHeight && (ly - y) / dt >= (C.swipeVelocity || 1.5)) fire();
      ly = y; lt = now;
    }, { passive: true });
    if (C.pageType === 'cart') {
      var idle;
      var reset = function () { clearTimeout(idle); idle = setTimeout(fire, 30000); };
      ['touchstart', 'scroll', 'keydown', 'click'].forEach(function (ev) { addEventListener(ev, reset, { passive: true }); });
      reset();
    }
  }

  // ---- F3 embedded entry ------------------------------------------------------
  // A div, not a <form>: the cart page container sits inside <form id="Cart">.
  var embedSeq = 0;
  function initEmbed() {
    if (!C.f3 || !C.embedSelector) return;
    var queued = 0;
    function inject() {
      queued = 0;
      var boxes;
      try { boxes = document.querySelectorAll(C.embedSelector); } catch (e) { return; }
      [].forEach.call(boxes, function (box) {
        if (box.querySelector('[data-cs-embedded]')) return;
        loadCss();
        var id = 'cs-embed-' + (++embedSeq);
        var d = document.createElement('div');
        d.className = 'cs-embed';
        d.setAttribute('data-cs-embedded', '');
        d.innerHTML =
          '<label class="cs-embed-label" for="' + id + '">' + esc(T.embedLabel) + '</label>' +
          '<div class="cs-embed-row">' +
            '<input id="' + id + '" class="cs-input" type="email" autocomplete="email" placeholder="' + esc(T.placeholder) + '">' +
            '<button type="button" class="cs-btn">' + esc(T.embedButton) + '</button>' +
          '</div>' +
          '<p class="cs-error" role="alert"></p>' +
          '<p class="cs-success" role="status" hidden>' + esc(T.embedSuccess) + '</p>';
        var input = d.querySelector('input');
        input.value = state.email || C.customerEmail || '';
        var go = function () {
          submitEmail(d, 'embedded', false, function () { d.querySelector('.cs-success').hidden = false; });
        };
        d.querySelector('button').addEventListener('click', go);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
        box.appendChild(d);
      });
    }
    inject();
    new MutationObserver(function () {
      if (!queued) { queued = 1; requestAnimationFrame(guard(inject)); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ---- F4 other forms ---------------------------------------------------------
  // Not marketing consent: never subscribes.
  function initForms() {
    if (!C.f4) return;
    var timer;
    function take(email) {
      if (!email || !EMAIL_RE.test(email = String(email).trim())) return;
      clearTimeout(timer); // Klaviyo forms can surface both as `submit` and `klaviyoForms`
      timer = setTimeout(function () { capture(email, 'other_form', false, false).catch(dbg); }, 500);
    }
    document.addEventListener('submit', guard(function (e) {
      var f = e.target;
      if (!f || !f.querySelectorAll || f.closest('[data-cs-form]')) return;
      var inputs = f.querySelectorAll('input[type=email], input[name*=email i]');
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].closest('[data-cs-embedded]') && inputs[i].value) return take(inputs[i].value);
      }
    }), true);
    addEventListener('klaviyoForms', guard(function (e) {
      var d = e.detail || {};
      if (d.type === 'submit' && d.metaData) take(d.metaData.email || d.metaData.$email);
    }));
  }

  // ---- Restore notices (set by the cart-restore page) -----------------------------
  function showNotice() {
    var n = ssGet('cs_notice');
    if (!n) return;
    try { sessionStorage.removeItem('cs_notice'); } catch (e) {}
    loadCss().then(guard(function () {
      var d = document.createElement('div');
      d.className = 'cs-notice';
      d.setAttribute('role', 'status');
      d.textContent = n === 'partial' ? T.noticePartial : T.noticeFailed;
      // Before the cart header, so it shares the page gutter (the section itself is full-bleed).
      var anchor = document.querySelector('.section-main-cart .cart-header') || document.querySelector('.section-main-cart');
      if (anchor) {
        d.className += ' cs-notice--inline';
        if (anchor.classList.contains('cart-header')) anchor.parentNode.insertBefore(d, anchor);
        else anchor.insertBefore(d, anchor.firstChild);
      }
      else { document.body.appendChild(d); setTimeout(function () { d.remove(); }, 8000); }
    }));
  }

  // ---- Boot -------------------------------------------------------------------
  window.CartSave = { getCart: getCart, normToken: normToken, reclaimUrl: reclaimUrl };
  if (/[?&]_kx=/.test(location.search)) ssSet('cs_pending', 'email_click');
  guard(sync)(true);
  guard(initExit)();
  guard(initEmbed)();
  guard(initForms)();
  guard(showNotice)();
  if (state.pd) profTimer = setTimeout(flushProfile, Math.max(0, 30000 - (Date.now() - state.pd)));
})();
